module.exports = __webpack_public_path__ + "img/tip_cards_styles.86d485f7.png";